import horizonJSON from '@utils/json';

import {ALERT_DETAILS_LOCAL_STORAGE_KEY} from '../../../constants/alert-filters';
import {EXPOSURE_TIME_PERIOD} from '../../../constants/person-filters';
import {horizonLocalStorage} from '../../../utils/local-storage';

/**
 * @param alertId
 * @param {object?} customDateRange
 * @param {string?} customDateRange.startDate - ISO DateTime string
 * @param {string?} customDateRange.endDate - ISO DateTime string
 */
export function setAlertDetailsCustomTimeRangeLocalStorage(alertId, customDateRange) {
  // check if any custom ranges exist
  const alertLocalStorage = getAlertDetailsCustomTimeRangeLocalStorage();
  const alertDetailsCustomTimeRange = {[alertId]: customDateRange};

  const combinedAlertDetailsCustomTime = {
    ...alertLocalStorage,
    ...alertDetailsCustomTimeRange,
  };
  horizonLocalStorage.setItem(ALERT_DETAILS_LOCAL_STORAGE_KEY, JSON.stringify(combinedAlertDetailsCustomTime));
}

export function getAlertDetailsCustomTimeRangeLocalStorage() {
  return horizonJSON.parse(horizonLocalStorage.getItem(ALERT_DETAILS_LOCAL_STORAGE_KEY));
}

export function clearAlertDetailsCustomTimeRangeLocalStorage() {
  horizonLocalStorage.removeItem(ALERT_DETAILS_LOCAL_STORAGE_KEY);
}

export function buildSiteFilter({
  polygons,
  distanceFromPolygon,
  applyVulnerabilityRadius,
  organizationIds,
  includeSubOrganizations,
}) {
  const siteFilter = {
    applyVulnerabilityRadius,
    polygons,
    distanceFromPolygon,
    organizationIds,
    includeSubOrganizations,
  };

  return siteFilter;
}

export function generateTimePeriodMap(exposureSummary, customDateRange) {
  return {
    [EXPOSURE_TIME_PERIOD.NOW]: {
      // fallback to site for case when site access but not persons
      dateStart: exposureSummary?.exposures?.now?.beginDate || exposureSummary?.exposures?.sites?.calculatedAt,
      dateEnd: exposureSummary?.exposures?.now?.endDate || exposureSummary?.exposures?.sites?.calculatedAt,
    },
    [EXPOSURE_TIME_PERIOD.NOW_THROUGH_END]: {
      dateStart: exposureSummary?.exposures?.nowThroughEnd?.beginDate,
      dateEnd: exposureSummary?.exposures?.nowThroughEnd?.endDate,
    },
    [EXPOSURE_TIME_PERIOD.CUSTOM_DURATION]: {
      dateStart: customDateRange?.beginDate,
      dateEnd: customDateRange?.endDate,
    },
    [EXPOSURE_TIME_PERIOD.ORIGINAL_THROUGH_END]: {
      // fallback to site for case when site access but not persons
      dateStart:
        exposureSummary?.exposures?.originalThroughEnd?.beginDate ||
        exposureSummary?.exposures?.originalSites?.calculatedAt,
      dateEnd:
        exposureSummary?.exposures?.originalThroughEnd?.endDate ||
        exposureSummary?.exposures?.originalSites?.calculatedAt,
    },
  };
}
